// TODO one SP-8718 is merged oto release, or common/actions/questionnaires is in the release, move the needed functions form current file to common/actions/questionnaires

import { FolderContext } from "@common/dto/folder/context";
import { HttpSuccessDto } from "@common/dto/http";
import { QuestionnaireCreateDto } from "@common/dto/questionnaire/create-dto";
import { QuestionnaireDefaultCreateDto } from "@common/dto/questionnaire/default-create-dto";
import { QuestionnaireFieldListDto } from "@common/dto/questionnaire/field/list-dto";
import { QuestionnaireGetExtendedDto } from "@common/dto/questionnaire/get-extended-dto";
import { QuestionnaireListCompactDto } from "@common/dto/questionnaire/list-compact-dto";
import { QuestionnaireAffectedFamilyPageGetDto } from "@common/dto/questionnaire/page/affected-family/get-dto";
import { QuestionnairePageGetDto } from "@common/dto/questionnaire/page/get-dto";
import { QuestionnairePageListDto } from "@common/dto/questionnaire/page/list-dto";
import { QuestionnaireUpdateDto } from "@common/dto/questionnaire/update-dto";
import client, { clientTransformed } from "@common/utils/rest";

import { FieldsToImportDto } from "../dto/fields-to-import-get-dto";

const getUrl = (path: string | number) => {
  return `api/questionnaire/${path}`;
};

export const getFhq4Questionnaires = (params: { includeFamily: boolean }): Promise<Array<QuestionnaireListCompactDto>> => {
  return clientTransformed({
    path: getUrl('fhq4'),
    params,
    method: 'GET',
  }).then((response: HttpSuccessDto<Array<QuestionnaireListCompactDto>>) => {
    return response.entity;
  });
};

export const deleteFhq4Questionnaire = async (id: QuestionnaireListCompactDto['questionnaireId']): Promise<void> => {
  await clientTransformed({
    path: getUrl(`fhq4/${id}/delete`),
    method: 'POST',
  });
};

export const saveFhq4Questionnaire = (questionnaire: QuestionnaireUpdateDto): Promise<QuestionnaireGetExtendedDto> => {
  return clientTransformed({
    path: getUrl('fhq4/update'),
    method: 'POST',
    entity: questionnaire,
  }).then((response: HttpSuccessDto<QuestionnaireGetExtendedDto>) => {
    return response.entity;
  });
};

export const copyFhq4Questionnaire = (questionnaireId: QuestionnaireListCompactDto['questionnaireId']): Promise<number> => {
  return clientTransformed({
    path: getUrl(`fhq4/${questionnaireId}/copy`),
    method: 'POST',
  }).then((response: HttpSuccessDto<number>) => {
    return response.entity;
  });
};

export const getFhq4Questionnaire = (id: QuestionnaireListCompactDto['questionnaireId']): Promise<QuestionnaireGetExtendedDto> => {
  return clientTransformed({
    path: getUrl(`fhq4/${id}`),
    method: 'GET',
  }).then((response: HttpSuccessDto<QuestionnaireGetExtendedDto>) => {
    return response.entity;
  });
};

export type AllQuestionnairePageGetDto = 
  QuestionnairePageGetDto |
  QuestionnaireAffectedFamilyPageGetDto;

export const getFhq4QuestionnairePage = async (questionnaireId: QuestionnaireListCompactDto['questionnaireId'], pageId: QuestionnairePageListDto['id']): Promise<AllQuestionnairePageGetDto> => {
  return clientTransformed({
    path: getUrl(`fhq4/${questionnaireId}/page/${pageId}`),
    method: 'GET',
  }).then((response: HttpSuccessDto<AllQuestionnairePageGetDto>) => {
    return response.entity;
  });
};

export type GetFhq4QuestionnaireFieldParams = {
  id: string | number;
  system: boolean;
  context: FolderContext;
};

export const getFhq4QuestionnaireField = async (field: GetFhq4QuestionnaireFieldParams): Promise<QuestionnaireFieldListDto> => {
  return clientTransformed({
    path: 'api/questionnaire/fhq4Field',
    params: field,
    method: 'GET',
  }).then((response: HttpSuccessDto<QuestionnaireFieldListDto>) => {
    return response.entity;
  });
};

export const getDefaultFhq4QuestionnaireForCreating = async (): Promise<QuestionnaireDefaultCreateDto> => {
  return clientTransformed({
    path: getUrl('fhq4/new'),
    method: 'GET',
  }).then((response: HttpSuccessDto<QuestionnaireDefaultCreateDto>) => {
    return response.entity;
  });
};

export const createFhq4Questionnaire = async (questionnaire: QuestionnaireCreateDto): Promise<QuestionnaireGetExtendedDto> => {
  return clientTransformed({
    path: getUrl('fhq4/update'),
    method: 'POST',
    entity: questionnaire,
  }).then((response: HttpSuccessDto<QuestionnaireGetExtendedDto>) => {
    return response.entity;
  });
};

export type ImportQuestionnaireParams = {
  file: File;
  name: string;
  createFields: boolean;
  fieldIds: Array<number>;
};

export const importQuestionnaire = async (payload: ImportQuestionnaireParams): Promise<void | { errors: Array<string> }> => {
  return client({
    path: getUrl("fhq4/import"),
    method: 'POST',
    headers: {
      "Content-Type": "multipart/form-data",
    },
    entity: payload,
  }).then((response: HttpSuccessDto<void | { errors: Array<string> }>) => {
    return response.entity;
  });
};

export const exportQuestionnaire = async (id: QuestionnaireListCompactDto['questionnaireId']): Promise<File> => {
  return client({
    path: getUrl(`fhq4/export/${id}`),
    method: 'GET',
  }).then((response: HttpSuccessDto<File>) => {
    return response.entity;
  });
};

export const getFieldsToImport = async (file: File): Promise<FieldsToImportDto> => {
  return client({
    path: getUrl("fhq4/fieldsToImport"),
    method: "POST",
    entity: {
      file,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }).then((response: HttpSuccessDto<FieldsToImportDto>) => {
    return response.entity;
  });
};
